import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { AppState } from '../../redux';
import PaymentRequestPage from './PaymentRequestPage';
import { getUserPaymentData, postPaymentDetails, checkoutPayment, isWaitingClear, savePfromDate, savePtoDate } from 'src/actions/paymentAction';
import { PaymentData } from 'src/reducers/payment';
import { printInvoice } from 'src/actions/paidInvoiceAction';

export const mapStateToProps = (state: AppState) => {
  return {
    paymentData: state.payment.getPaymentData,
    paymentId: state.payment.paymentId,
    isWaiting: state.payment.isWaiting,
    // totalAmount: state.payment.paymentAmount,
    // totalUnits: state.payment.unitTotal
    startDate: state.payment.startPDate,
    endDate: state.payment.endPDate
  };
};

export const mapDispatchToProps = (dispatch: Dispatch<AppState>) => {
  return {
    onComponentDidMount: () => {
      dispatch(getUserPaymentData('initialcall'));
    },
    details: (total: number, tableData: PaymentData[] | PaymentData) => {
      dispatch(postPaymentDetails(total, tableData));
    },
    // paymentAmount: (amount: number) => {
    //   dispatch(totalAmount(amount));
    // },
    // unitTotal: (units: number) => {
    //   dispatch(totalUnits(units));
    // },
    isWaitingClose: () => {
      dispatch(isWaitingClear);
    },
    reload: () => {
      dispatch(getUserPaymentData('reset'));
    },
    paymentCall: (amount: number) => {
      dispatch(checkoutPayment(amount));
    },
    fDate: (fromDate: Date | null) => {
      dispatch(savePfromDate(fromDate));
    },
    toDate: (toDate: Date | null) => {
      dispatch(savePtoDate(toDate));
    },
    dateFilter: () => {
      dispatch(getUserPaymentData('get'));
    },
    dateReset: () => {
      dispatch(getUserPaymentData('reset'));
    },
    printTxn: (txn: String) => {
      dispatch(printInvoice(txn, ''));
    }
  };
};

const PaymentRequestPageContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(PaymentRequestPage);

export default PaymentRequestPageContainer;



// WEBPACK FOOTER //
// ./src/components/PaymentRequest/PaymentRequestPageContainer.tsx